import { DetailsList } from "react-migration/components/DetailsList";
import { updateDrawing } from "src/js/stores/drawing/actions/updateDrawing";
import { AnnotationSpecProps } from "./types";

export function TextBoxSpec({ drawing }: AnnotationSpecProps) {
  const onTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newDrawing = {
      ...drawing,
      properties: {
        ...drawing.properties,
        text: e.target.value,
      },
    };

    updateDrawing(newDrawing, true);
  };

  return (
    <DetailsList>
      <DetailsList.Item label={"Update text"}>
        <textarea
          className="appearance-none px-3 py-2 text-md w-full border border-solid border-neutral-300 focus:border-border-action-focus rounded-md"
          onChange={onTextChange}
          value={drawing.properties.text}
          autoFocus
        />
      </DetailsList.Item>
    </DetailsList>
  );
}
